import request from '@/utils/request'
import qs from 'qs'
export function getRefundList(query) {
  return request({
    url: '/report-service/v1/report/room-transaction-refund',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
